<template>
  <div></div>
</template>

<script>
export default {
  name: 'Blank'
}
</script>
